<p-toast key="employee-toast" position="top-right">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-col gap-3 w-full">
      <div class="flex items-center gap-3">
        <i class="pi pi-verified text-3xl"></i>
        <div class="flex flex-col flex-1">
          <span class="font-semibold text-lg">{{ message.summary }}</span>
          <span class="text-sm mt-1">{{ message.detail }}</span>
        </div>
      </div>
      @if (message.data?.actions && message.data.actions.length > 0) {
        <div class="flex justify-end gap-2">
          @for (action of message.data.actions; track action.label) {
            <button 
              type="button"
              [class]="action.styleClass || 'px-4 py-2 bg-white text-gray-900 rounded-md font-medium hover:bg-gray-100 transition-colors'"
              (click)="onToastAction(action, message)"
            >
              {{ action.label }}
            </button>
          }
        </div>
      }
    </div>
  </ng-template>
</p-toast>
<router-outlet></router-outlet>
<div id="mask"></div>